<template>
    <div v-if="isLoaded">
        <div id="shop_label">
            {{lbl.shop_input_label}} <span class="star">*</span>
        </div>
        <div class="text-warning-shop">
            {{ lbl.shop_text_warning }}
        </div>
        <DropdownFilterInput 
            :errorInfo="errorFilterInfo[0]"
            inputId="filter_province"
            :inputLbl="lbl.province"
            :isShowError="isShowError"
            :isSubmitted="isSubmitted"
            :itemList="provinceList"
            v-if="isShowProvinceDropdown"
            v-model="selectedProvince"
            @onChangeFilter="onChangeProvince($event)" /> 
        <DropdownFilterInput 
            :errorInfo="errorFilterInfo[1]"
            inputId="filter_shop"
            :inputLbl="lbl.shop"
            :isDisable="!isShopLoaded"
            :isShowError="isShowError"
            :isSubmitted="isSubmitted"
            :itemList="shopList"
            v-if="isShowShopDropdown"
            v-model="selectedShopName"
            @onChangeFilter="onChangeShop($event)" />
 
        <div id="shop_section"
            v-if="isShowOtherShopName">
            <TextInput
                addClass="ep-input"
                :errorInfo="errorOtherInfo[0]"
                inputId="other_shop_input"
                :inputLbl="lbl.other_shop"
                :inputMaxLength="60"
                :isHideLabel="true"
                :isShowError="isShowError"
                :isSubmitted="isSubmitted"
                v-model="otherShopName"
                @input="onChangeOtherShop($event)" />
        </div>
    </div>
</template>
<script>
// helper
import FormHelper from '@/helper/FormHelper.js';
// mixin
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
// component
import TextInput from '@/components/Input/Text.vue';
import DropdownFilterInput from '@/components/Input/DropdownFilter.vue';
// service
import CpfService from '@/core/Custom/CpfService.js';
export default {
    name: 'ShopInput',
    mixins: [ErrorApiMixin],
    components: {
        DropdownFilterInput,
        TextInput
    },
    props: {
        lbl: Object,
        modalController: Object,
        errorInfo: Object,
        isShowError: Boolean,
        isSubmitted: Boolean,
        shopInfo: Object
    },
    data: function () {
        return {
            isLoaded: false,
            isLoading: false,

            isShowProvinceDropdown: false,
            provinceList: [],
            selectedProvince: '',

            isInitShopInfo: false,
            isShopLoaded: false,
            isShowShopDropdown: false,
            shopList: [],
            selectedShopName: '',
            selectedShopItem: {},

            isShowOtherShopName: false,
            otherShopName: '',
            shopInfoForm: this.shopInfo,

            errorFilterInfo: [],
            errorOtherInfo: [],
            errorHandler: null
        };
    },
    watch: {
        otherShopName: function () {
            this.validate();
        },
        shopInfo: function (newVal) {
            this.shopInfoForm = newVal;
            
            if (newVal) {
                this.isInitShopInfo = true;
                this.otherShopName = this.shopInfoForm.ShopName;
                this.selectedProvince = this.shopInfoForm.Province;
                this.selectedShopItem = {
                    province: this.shopInfoForm.Province,
                    shopName: this.shopInfoForm.ShopName,
                };
            }
            this.onChangeProvince(this.selectedProvince);
        }
    },
    created: async function () {
        // error info
        this.errorFilterInfo = new FormHelper.genErrorInfo(2);
        this.errorOtherInfo = new FormHelper.genErrorInfo(1);
        // error handler
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setTitle(this.lbl.register_alert_headline);
        this.errorHandler.setAlertModal(this.modalController.alertModal);
        
        if (this.shopInfo) {
            this.isInitShopInfo = true;
            this.otherShopName = this.shopInfo.ShopName;
            this.selectedProvince = this.shopInfo.Province;
            this.selectedShopItem = this.shopInfo;
        }
        this.showLoading();
        await this.getProvinceList();
        setTimeout(() => {
            this.hideLoading();
        }, 1000)
    },
    methods: {
        //#region event
        onChangeProvince: function (value) {
            if (!value) {
                this.selectedShopItem = {};
                this.selectedShopName = '';
                this.shopList = [];
                this.isShopLoaded = false;
                this.isShowOtherShopName = false;
                this.otherShopName = '';
            } else {
                this.getShopByProvince(value.text);
            }
        },
        onChangeShop: function (value) {
            
            if (!value) {
                this.otherShopName = '';
                this.isShowOtherShopName = false;
            } else {
                this.selectedShopItem = value.item;
                this.selectedShopName = value.text;
                this.setOtherShopInfo();
            }
            
            this.$nextTick(() => {
                this.$emit('inputShop', true);
                this.validate();
            });
        },
        onChangeOtherShop: function (value) {
            if (value) {
                this.$emit('inputShop', true);
            }
        },
        //#endregion event
        //#region methods
        getShopInfo: function () {
            if (this.validate()) {
                const shopInfo = {...this.selectedShopItem};
                
                shopInfo.shopName = this.isShowOtherShopName 
                    ? this.otherShopName 
                    : this.selectedShopItem.shopName;
                    
                return shopInfo;
            }

            return null;
        },
        setOtherShopInfo: function () {
            const shopName = this.cleanText(this.selectedShopName);
            this.isShowOtherShopName = (shopName === 'อื่นๆ');
        },
        validate: function () {
            const validateFilter = FormHelper.validate(this.errorFilterInfo);
            if (validateFilter) {
                if (this.isShowOtherShopName) {
                    const validateShopName = FormHelper.validate(this.errorOtherInfo);
                    
                    if (validateShopName) {
                        this.errorInfo.isValid = true;
                        this.errorInfo.msg = '';
                        
                        return true;
                    } 
                } else {
                    this.errorInfo.isValid = true;
                    this.errorInfo.msg = '';
                    
                    return true;
                }
            } 
           
            this.errorInfo.isValid = false;
            this.errorInfo.msg = this.lbl.form_error_label;
            return false;
        },
        //#endregion methods
        //#region service
        getProvinceList: function () {
            // this.showLoading();
            return new Promise((resolve) => {
                CpfService.getProvinceList().then((res) => {
                    for (const province of res.data) {
                        this.provinceList.push({
                            text: province,
                            value: province
                        })
                    }

                    if (this.isInitShopInfo) {
                        this.selectedProvince = this.shopInfo.Province;
                        this.getShopByProvince();
                    }

                    this.isShowProvinceDropdown = true;
                    this.isShowShopDropdown = true;
                    this.isLoaded = true;
                    this.modalController.loadingModal.hide();
                    resolve(res.data);
                })
                .catch((err) => {
                    this.modalController.loadingModal.hide();
                    this.errorResponse(err, this.errorHandler);
                    // reject(false);
                });
            });
        },
        getShopByProvince: function () {
            this.showLoading();
            CpfService.getShopByProvince(this.selectedProvince)
                .then(res => {
                    this.shopList = [];
                    
                    for (const shop of res) {
                        this.shopList.push({
                            text: shop.shopName,
                            value: shop.shopId,
                            item: shop
                        });
                    }
                    
                    if (this.otherShopName != '') {
                        const filteredShopItem = this.shopList.find((shop) => {
                            return shop.text == this.otherShopName;
                        });
                        
                        if (filteredShopItem == undefined) {
                            this.selectedShopName = 'อื่นๆ';  
                            const filteredShopId = this.shopList.find(shop => shop.text == this.selectedShopName);
                            this.selectedShopItem.shopId = filteredShopId.value;
                            
                            this.setOtherShopInfo();
                        } else {
                            this.selectedShopName = filteredShopItem.text;
                            this.selectedShopItem.shopId = filteredShopItem.value;
                        }
                    } else if (this.isInitShopInfo) {
                        const filteredShopItem = this.shopList.find(shop => shop.shopName == this.shopInfo.ShopName);
                        
                        if (filteredShopItem != undefined) {
                            this.selectedShopName = filteredShopItem.text;
                            this.selectedShopItem.shopId = filteredShopItem.value;
                        }
                        
                        this.setOtherShopInfo();
                    }

                    this.isLoading = false;
                    this.isShopLoaded = true;
                    this.refreshShopDropdown();
                    this.modalController.loadingModal.hide();
                }).catch(err => {
                    this.isLoading = false;
                    console.log('err', err);
                    
                    this.errorResponse(err, this.errorHandler);
                    this.modalController.loadingModal.hide();
                });
        },
        //#endregion service
        //#region util
        refreshShopDropdown: function () {
            if (!this.isInitShopInfo) {
                this.selectedShopName = '';
                this.selectedShopItem = {};
            }
            
            this.isInitShopInfo = false;
            this.isShowShopDropdown = false;
            this.$nextTick(() => {
                this.isShowShopDropdown = true;
            });
        },
        cleanText: function (text) {
            // const reg = /\s/g;
            // return text.replace(reg, '');
            return text.trim();
        },
        showLoading: function () {
            if (this.isLoading) return true;
            this.isLoading = true;

            this.modalController.loadingModal.show();
        },
        hideLoading: function () {
            this.isLoading = false;
            this.modalController.loadingModal.hide();
        }
        //#endregion util
    }
}
</script>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/base/common.scss";
.shop-input {
    @include baseShopOther();
}
</style>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/common.scss";

    #shop_label {
        color: $a-gray-575757;
        font-size: 1.5rem; 
        .star {
            color: $input-error-color;
        } 
    }
    .text-warning-shop {
        color: $a-yellow-EDA145;
        font-size: 1.25rem;
    }

    .ep-input {
        @include baseProfileInput; 

        &:nth-last-child(1) {
            margin-bottom: 12px;
        }

        .input-wrapper {
            input {
                height: 50px;
                // padding-left: 115px; 
                border: 1px solid #C4C4C4;
                font-size: 24px;

                @media (max-width: $max-width-mini-mobile) {
                    padding-left: 16px;
                    font-size: 1.4rem;
                }
            }

            .input-lbl {
                color: $text-gray;
                font-size: 1.45rem;

                @media (max-width: $max-width-mini-mobile) {
                    font-size: 1.4rem;
                }
            }
        }
    } 
</style>